var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "0 auto",
      background: "0 0"
    },
    preserveAspectRatio: "xMidYMid",
    display: "block",
    viewBox: "0 0 100 100"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "none",
    stroke: "#3273fa",
    strokeWidth: 10,
    r: 43,
    strokeDasharray: "202.63272615654165 69.54424205218055",
    transform: "rotate(75.138 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1"
  }))));
}
export default __webpack_public_path__ + "static/svg/spinner.svg";
export { SvgSpinner as ReactComponent };